export const regionSwitch = {
  us: "US",
  ca: "CA",
  nova: "NOVA",
  usLoginPage: "United States login page",
  caLoginPage: "Canada login page",
  novaLoginPage: "NOVA login page",
  goToUS: "Go to Fullscript US",
  goToCA: "Go to Fullscript Canada",
  goToNova: "Go to NOVA",
} as const;
